const AuthService = {
    isLoggedIn: function () {
        var str=localStorage.getItem('token')
        if (str) {
            var token = JSON.parse(str);
            return true;
        } 
        return false;
    },
    logOut: function () {
        localStorage.removeItem('token');
    },
    getToken: function () {
        var str = localStorage.getItem('token')
        if (str) {
            var token = JSON.parse(str);
            return token;
        }
        return null;
    }
}

export default AuthService